import {
  createRouter,
  createWebHashHistory,
  RouteRecordRaw,
  createWebHistory,
} from "vue-router";
import Layout from "../layout/Layout.vue";
const _import = (path: string): any => import(`../views/${path}.vue`);
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "login",
    component: () => import("@/views/login/index.vue"),
  },
  {
    path: "/app-login",
    name: "app-login",
    component: () => import("@/views/login/index.vue"),
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("@/views/logout/index.vue"),
  },
  {
    path: "/home",
    component: () => import("@/views/home.vue"),
  },
  {
    path: "/room",
    component: () => import("@/views/room.vue"),
  },
  {
    path: "/privacy-user",
    component: () => import("@/views/privacy/user.vue"),
  },
  {
    path: "/privacy-policy",
    component: () => import("@/views/privacy/policy.vue"),
  },
  // {
  //   path: "/",
  //   name: "main",
  //   component: Layout,
  //   redirect: "/order/index",
  //   children: [
  //     // {
  //     //   // 订单
  //     //   path: "/order/test",
  //     //   name: "order1",
  //     //   component: () => import("../views/posted/text.vue"),
  //     // },
  //   ],
  // },
];

const router = createRouter({
  // history: createWebHashHistory(process.env.VITE_APP_PUBLIC_PATH),
  history: createWebHistory(import.meta.env.VITE_APP_PUBLIC_PATH as string), // history模式
  routes,
});
export default router;
